import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
import classNames from 'classnames';

const DatePicker = ({ field, form, ...other }) => {
  const classes = useStyles();
  const currentError = form.errors[field.name];

  return (
    <KeyboardDatePicker
      clearable
      inputVariant={'outlined'}
      className={ classNames(classes.date, !!currentError && classes.errorInput) }
      InputAdornmentProps={{ 'classes': { 'root': classes.dateIcon } }}
      name={field.name}
      value={field.value}
      format="MM/dd/yyyy"
      helperText={currentError}
      error={Boolean(currentError)}
      onError={error => {
        // handle as a side effect
        if (error && error !== currentError) {
          form.setFieldError(field.name, error);
        }
      }}
      // if you are using custom validation schema you probably want to pass `true` as third argument
      onChange={date => form.setFieldValue(field.name, date, true)}
      {...other}
    />
  );
};

const useStyles = makeStyles(
  theme => {
    return {
      date: {
        width: '100%',
      },
      errorInput: {
        '& label': {
          color: '#CF0000',
        },
        '& div.MuiInputBase-root fieldset': {
          borderColor: '#CF0000',
        },
        '& p.MuiFormHelperText-root': {
          color: '#CF0000',
        },
      },
      dateIcon: {
        // display: 'none',
      },
    };
  }
);

export default DatePicker;
